export default __webpack_public_path__ + "static/media/instagram_icon.be662ef5.png";